import React from 'react'
import { IonPage, IonContent, IonText, useIonViewDidEnter } from '@ionic/react'
import Header from '../../components/Header'
import { AddIcon, DeleteDisableIcon } from '../../conf/images'
//@ts-ignore
import { getNewsBotSettingList } from '../../service/api/bot'
import NewsBotDetailItem from './Item'
import './index.css'
import { useHistory } from 'react-router'
import { SetNewsBotPage } from '../../conf/routePath'

export type ContactsType = {
    contacts_type: string
    describe: string
    head_url: string
    name: string
    uid: string
}

export type NewsBotSetting = {
    name: string
    friend_reply_object_type: string
    friend_reply_list: ContactsType[]
    group_reply_object_type: string
    group_reply_list: ContactsType[]
    reply_frequency: string
    days_of_week: string[]
    day_of_once: string
    reply_time: string
    keyword: string
    id: string
}

const NewsBotDetail: React.FC<{}> = (props) => {
    const history = useHistory()
    const [list, setList] = React.useState<NewsBotSetting[]>([])
    const [listMode, setListMode] = React.useState<boolean>(true)

    const removeItem = (id) => {
        setList((item) => item.filter((v) => v.id !== id))
    }
    useIonViewDidEnter(() => {
        getNewsBotSettingList().then((res: { data: NewsBotSetting[] }) => {
            setList(res.data)
        })
    }, [])

    return (
        <IonPage>
            <IonContent className='mybot-content'>
                <Header title='新闻头条' backable>
                    {!!list?.length && (
                        <img
                            className='newsBotSetDelIcon'
                            src={DeleteDisableIcon}
                            alt='store'
                            onClick={() => setListMode((b) => !b)}
                        />
                    )}
                    <img
                        className='newsBotSetAddIcon'
                        src={AddIcon}
                        alt='store'
                        onClick={() => {
                            history.push(SetNewsBotPage)
                        }}
                    />
                </Header>
                {Array.isArray(list) && list.length > 0 ? (
                    list.map((item) => (
                        <NewsBotDetailItem
                            mode={listMode}
                            key={item.id}
                            item={item}
                            removeItem={removeItem}
                        />
                    ))
                ) : (
                    <div className='newsBotNotSetting'>
                        <IonText>还没有任何推送配置，点击右上角添加吧!</IonText>
                    </div>
                )}
            </IonContent>
        </IonPage>
    )
}

export default NewsBotDetail
